import script from "./AllNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./AllNotifications.vue?vue&type=script&setup=true&lang=js"

import "./AllNotifications.vue?vue&type=style&index=0&id=254f587d&lang=css"

const __exports__ = script;

export default __exports__